import { useEffect } from 'react';
import * as QuestionnaireApiModels from '@typings/questionnaires-api-models';
import simpleDebug from '@/helpers/simpleDebug';

type OptionsList = { key: string; label: string; isDefault: boolean; }[];

type Props = {
  formData: {
    sections: Array<{
      fields: Array<
        & Pick<QuestionnaireApiModels.FieldTemplate,
          | 'key'
        >
        & {
          // @todo - clean up FieldTemplate.options and .referencedList typing, shouldn't be optional anywhere
          options?: QuestionnaireApiModels.FieldTemplate['options'];
          referencedList?: QuestionnaireApiModels.FieldTemplate['referencedList'];
        }
      >;
    }>;
  }
  formValues: Record<string, unknown>;
};

const HandleFieldDynamicOptions: React.FC<Props> = ({ formData, formValues }) => {
  useEffect(() => {
    formData.sections.forEach(section => {
      section.fields.forEach(field => {
        if(field.referencedList?.isReferencingExistingList) {
          const optionsList: OptionsList = [];
          const fieldKey = field.referencedList?.fieldKey;
          const subFieldKey = field.referencedList?.subFieldKey;
          const formValuesList = formValues[fieldKey];
          if (Array.isArray(formValuesList)) {
            formValuesList.forEach((item: { [key: string]: string | undefined; _id?: string }) => {
              if (item && typeof item === 'object' && subFieldKey in item) {
                const itemId = (item._id as string) || `${item[subFieldKey]}`;
                optionsList.push({
                  isDefault: false,
                  key: itemId,
                  label: item[subFieldKey] as string,
                });
              }
            });
          }
          simpleDebug(field.key, 'updating options', field.key, optionsList);
          const existingOptions = field.options || [];
          const updatedOptions = optionsList.map(option => {
            const existingOption = existingOptions.find(e => e.label === option.label);
            return existingOption || option;
          });

          // @todo - we should not be mutating the field object directly...
          Object.assign(field, { ...field, options: updatedOptions });
        }
      });
    });
  }, [formData, formValues]);

  return null;
};

export default HandleFieldDynamicOptions;